<template>
  <div
    v-if="guest"
    class="scale-workspace-banner"
    role="status"
    aria-live="polite"
  >
    <span class="scale-workspace-banner__dot" aria-hidden="true" />
    <span class="scale-workspace-banner__text">
      Working in <strong>{{ workspaceLabel }}</strong>
      <span v-if="appsLabel" class="scale-workspace-banner__apps">· Shared with you: {{ appsLabel }}</span>
    </span>
    <button
      type="button"
      class="scale-workspace-banner__leave"
      :disabled="leaving"
      @click="leave"
    >
      {{ leaving ? 'Returning…' : 'Return to my account' }}
    </button>
  </div>
</template>

<script>
import {
  WORKSPACE_CHANGED_EVENT,
  currentWorkspaceGuest,
  returnToOwnAccount
} from '@/services/scaleWorkspace';

const APP_NAMES = {
  groovecm: 'Dashboard',
  groovepages: 'GroovePages',
  groovesell: 'GrooveSell',
  groovemail: 'GrooveMail',
  groovemember: 'GrooveMember',
  groovevideo: 'GrooveVideo',
  grooveblog: 'GrooveBlog',
  groovewebinar: 'GrooveWebinar'
};

export default {
  name: 'ScaleWorkspaceBanner',

  data: () => ({
    guest: currentWorkspaceGuest(),
    leaving: false
  }),

  computed: {
    workspaceLabel() {
      const { workspaceName, ownerName } = this.guest;
      if (workspaceName && ownerName && workspaceName !== ownerName) {
        return `${workspaceName} (${ownerName})`;
      }
      return workspaceName || ownerName || 'a shared workspace';
    },
    appsLabel() {
      return this.guest.allowedApplications
        .filter(slug => slug !== 'groovecm')
        .map(slug => APP_NAMES[slug])
        .join(', ');
    }
  },

  mounted() {
    window.addEventListener(WORKSPACE_CHANGED_EVENT, this.update);
  },

  beforeDestroy() {
    window.removeEventListener(WORKSPACE_CHANGED_EVENT, this.update);
  },

  methods: {
    update() {
      this.guest = currentWorkspaceGuest();
    },
    async leave() {
      this.leaving = true;
      await returnToOwnAccount();
    }
  }
};
</script>

<style scoped>
.scale-workspace-banner {
  position: fixed;
  left: 50%;
  bottom: 16px;
  transform: translateX(-50%);
  z-index: 10000;
  display: flex;
  align-items: center;
  gap: 12px;
  max-width: calc(100vw - 32px);
  padding: 8px 8px 8px 16px;
  border-radius: 999px;
  background: #111827;
  color: #f9fafb;
  font-size: 13px;
  line-height: 1.4;
  box-shadow: 0 8px 24px rgba(17, 24, 39, 0.25);
}

.scale-workspace-banner__dot {
  flex: none;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #34d399;
}

.scale-workspace-banner__text {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.scale-workspace-banner__apps {
  color: #d1d5db;
}

.scale-workspace-banner__leave {
  flex: none;
  padding: 6px 12px;
  border: 0;
  border-radius: 999px;
  background: #f9fafb;
  color: #111827;
  font-weight: 600;
  font-size: 12px;
  cursor: pointer;
}

.scale-workspace-banner__leave:disabled {
  opacity: 0.6;
  cursor: default;
}

.scale-workspace-banner__leave:focus-visible {
  outline: 2px solid #34d399;
  outline-offset: 2px;
}

@media (max-width: 640px) {
  .scale-workspace-banner__apps {
    display: none;
  }
}
</style>
